import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import {
  NATIONAL_IDENTIFICATION_DESER,
  NationalIdentification,
} from "./national-identification"

export class PersonalIdentity {
  nationalIdentification?: NationalIdentification
}

export const PERSONAL_IDENTITY_DESER: SchemaDeSer<PersonalIdentity> =
  new SchemaDeSerBuilder(PersonalIdentity)
    .ofNested(
      "nationalIdentification",
      NATIONAL_IDENTIFICATION_DESER,
      NationalIdentification
    )
    .toDeSer()
